import React, {createContext} from 'react';

export interface PopoverContextProps {
    open: boolean;
    handleToggle: () => void;
    handleClose: (event: Event | React.SyntheticEvent) => void;
    handleKeyDown?: (event: React.KeyboardEvent) => void;
    popoverId?: string;
    anchorRef: React.RefObject<HTMLElement> | null;
    showClose?: boolean;
}

export const PopoverContext = createContext<PopoverContextProps | undefined>(undefined);

export const usePopoverContext = (currentComponent: string): PopoverContextProps => {
    const context = React.useContext(PopoverContext);

    if (context === undefined) {
        throw Error(
            `Popover ${currentComponent} must be used inside of a Popover, ` +
      'otherwise it will not function correctly.'
        );
    }
    return context;
};
